import { __makeTemplateObject, __read } from "tslib";
import React from 'react';
import styled from 'styled-components';
import { gridSize, fontSize, colors } from '@atlaskit/theme';
import ChevronRightIcon from '@atlaskit/icon/glyph/chevron-right';
import Tooltip from '@atlaskit/tooltip';
import { expandMessages, sharedExpandStyles, WidthProvider, ExpandIconWrapper, ExpandLayoutWrapper, ClearNextSiblingMarginTop, } from '@atlaskit/editor-common';
import { PLATFORM, MODE } from '../analytics/events';
import { ACTION, ACTION_SUBJECT, EVENT_TYPE } from '../analytics/enums';
import { injectIntl } from 'react-intl';
var Title = styled.span(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  outline: none;\n  border: none;\n  font-size: ", "px;\n  line-height: 1.714;\n  font-weight: normal;\n  display: flex;\n  flex: 1;\n  margin: 0;\n  padding: 0 0 0 ", "px;\n  text-align: left;\n"], ["\n  outline: none;\n  border: none;\n  font-size: ", "px;\n  line-height: 1.714;\n  font-weight: normal;\n  display: flex;\n  flex: 1;\n  margin: 0;\n  padding: 0 0 0 ", "px;\n  text-align: left;\n"])), fontSize, gridSize() / 2);
var Container = styled.div(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  ", "\n  padding: 0;\n  padding-bottom: ", "px;\n"], ["\n  ", "\n  padding: 0;\n  padding-bottom: ", "px;\n"])), sharedExpandStyles.ContainerStyles, function (props) { return (props.expanded ? gridSize() : 0); });
var TitleContainer = styled.button(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n  ", "\n  padding: ", "px;\n  padding-bottom: ", "px;\n"], ["\n  ", "\n  padding: ", "px;\n  padding-bottom: ", "px;\n"])), sharedExpandStyles.TitleContainerStyles, gridSize(), function (props) { return (!props.expanded ? gridSize() : 0); });
TitleContainer.displayName = 'TitleContainerButton';
var ContentContainer = styled.div(templateObject_4 || (templateObject_4 = __makeTemplateObject(["\n  ", ";\n  padding-right: ", "px;\n  padding-left: ", "px;\n"], ["\n  ", ";\n  padding-right: ", "px;\n  padding-left: ", "px;\n"])), sharedExpandStyles.ContentStyles, gridSize() * 2, gridSize() * 5 - gridSize() / 2);
function fireExpandToggleAnalytics(nodeType, expanded, fireAnalyticsEvent) {
    if (!fireAnalyticsEvent) {
        return;
    }
    fireAnalyticsEvent({
        action: ACTION.TOGGLE_EXPAND,
        actionSubject: nodeType === 'expand'
            ? ACTION_SUBJECT.EXPAND
            : ACTION_SUBJECT.NESTED_EXPAND,
        attributes: {
            platform: PLATFORM.WEB,
            mode: MODE.RENDERER,
            expanded: !expanded,
        },
        eventType: EVENT_TYPE.TRACK,
    });
}
function Expand(_a) {
    var title = _a.title, children = _a.children, nodeType = _a.nodeType, intl = _a.intl, fireAnalyticsEvent = _a.fireAnalyticsEvent;
    var _b = __read(React.useState(false), 2), expanded = _b[0], setExpanded = _b[1];
    var label = intl.formatMessage(expanded ? expandMessages.collapseNode : expandMessages.expandNode);
    return (React.createElement(Container, { "data-node-type": nodeType, "data-title": title, expanded: expanded },
        React.createElement(TitleContainer, { onClick: function (e) {
                e.stopPropagation();
                fireExpandToggleAnalytics(nodeType, expanded, fireAnalyticsEvent);
                setExpanded(!expanded);
            }, "aria-label": label, contentEditable: false, expanded: expanded },
            React.createElement(Tooltip, { content: label, position: "top", tag: ExpandLayoutWrapper },
                React.createElement(ExpandIconWrapper, { expanded: expanded },
                    React.createElement(ChevronRightIcon, { label: label, primaryColor: colors.N80A }))),
            React.createElement(Title, null, title || intl.formatMessage(expandMessages.expandDefaultTitle))),
        React.createElement(ContentContainer, { expanded: expanded },
            React.createElement("div", { className: nodeType + "-content-wrapper" },
                React.createElement(WidthProvider, null,
                    React.createElement(ClearNextSiblingMarginTop, null),
                    children)))));
}
export default injectIntl(Expand);
var templateObject_1, templateObject_2, templateObject_3, templateObject_4;
//# sourceMappingURL=Expand.js.map